<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center space-x-3">
      <PromocodeIcon />
      <span class="text-text-neutral-primary font-medium">{{
        $t('promocode.title')
      }}</span>
    </div>
    <FreeSwitch
      :checked="model"
      :disabled="isLoading"
      @onChange="model = !model"
    />
  </div>
</template>

<script setup lang="ts">
  import { FreeSwitch } from 'freedom-shared';

  import PromocodeIcon from '../assets/promocode.icon.svg?component';

  defineProps<{ isLoading: boolean }>();
  const model = defineModel<boolean>();
</script>
